import { useMemo } from 'react'
import auth from '../../../api/auth/hooks'
import { ProjectItem } from '../../../api/projects/types'
import { projectGeneralFields } from '../../../common/forms/projects/fields'
import { projectGeneralInputs } from '../../../common/forms/projects/inputs'
import { projectGeneralValidaton } from '../../../common/forms/projects/validation'
import { addRequiredValidation } from '../../../utils/formUtils/forms'
import { Field, FieldGroup } from '../../../utils/formUtils/types'

export const useProjectGeneralFormConfig = (data: ProjectItem) => {
    const { data: currentAgentId } = auth.CurrentAgent.useQuery({ select: (data) => data.id })

    return useMemo(() => {
        const generalInputs = projectGeneralInputs()
        const generalValidationConfig = projectGeneralValidaton(data)
        const flattenedGeneralInputs = [generalInputs.sideForm, generalInputs.mainForm].flat(Infinity).filter(Boolean) as (Field | FieldGroup)[]

        if (!generalValidationConfig.initialValues[projectGeneralFields.AGENT_ID] && currentAgentId) {
            generalValidationConfig.initialValues[projectGeneralFields.AGENT_ID] = currentAgentId
        }

        addRequiredValidation(generalValidationConfig.validationSchema.fields, flattenedGeneralInputs)

        return {
            generalInputs,
            generalValidationConfig,
        }
    }, [data, currentAgentId])
}
